module.exports = "## App Bar\n\nApp bars are a collection of components placed as a static header for an application.\nIt is used for navigation, search branding, and actions.\nAn app bar is also referred to as the primary toolbar or action bar for Android.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/AppBar/README.md
 ** module id = 765
 ** module chunks = 0
 **/